export const formatCurrency = (amount, currency = 'INR') => {
  // If amount is missing, default to showing 0 in the requested currency
  const safeAmount = amount === undefined || amount === null ? 0 : amount;
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 0,
  }).format(safeAmount);
};
